/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */

/**
 * AnalyticsIds defines the unique identifiers used for tracking 
 * various user interactions and elements within the application.
 * 
 * Each enum value is mapped to a specific component or feature, and is
 * intended to be used as an 'id' attribute or data attribute for analytics tracking.
 * 
 * This centralizes the IDs used for analytics tracking, making it easier to manage
 * and maintain consistency across the application.
 */
export enum AnalyticsIds {
  // Desktop Header Analytics IDs
  desktopHeaderNotification = 'desktopHeader-notification',
  helpCenterIcon = 'help-center-icon',
  // Service Log Analytics IDs
  serviceLogInvoiceTotalCost = 'serviceLog-invoice-totalCost',
  serviceLogInvoiceParts = 'serviceLog-invoice-parts',
  serviceLogInvoiceLabor = 'serviceLog-invoice-labor',
  serviceLogInvoiceMisc = 'serviceLog-invoice-misc',
  serviceLogInvoiceTax = 'serviceLog-invoice-tax',
  // Asset History Analytics IDs
  assetHistoryCategoryFilter = 'assetHistory-categories-filter',
  assetHistoryBoundaryFilter = 'assetHistory-boundary-filter',
  assetHistoryEventFilter = 'assetHistory-event-filter',
  assetHistoryGroupFilter = 'assetHistory-group-filter',
  assetHistoryDateFilter = 'assetHistory-date-filter',
  assetHistoryTypeFilter = 'assetHistory-type-filter',
  // Vision Analytics IDs
  visionAssetDetailsAccordion = 'vision-asset-details-accordion',
  visionHarshEventThumbnail = 'vision-harsh-event-thumbnail',
  visionActionsDvrRequest = 'vision-actions-dvr-request',
  visionActionsPlayIcon = 'vision-grid-actions-play-icon',
  visionRequests = 'vision-requests',
  visionSuccess = 'vision-success',
  visionError = 'vision-error',
  visionGrid = 'vision-grid',
  // CTC Admin Specific Analytics IDs
  desktopHeaderOldCTCSwitch = 'desktopHeader-old-ctc-switch',
  // General Analytics IDs
  ionGrid = 'ion-grid'
};
